export default __webpack_public_path__ + "static/media/may2023.b75a13df.png";